/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

type ConfigResponse = {
	isReportingEnabled: boolean;
};

export const SUMMARY_PAGE_CONFIG_RESOURCE_KEY = 'SERVICE_DESK_PROJECT_SUMMARY_CONFIG';

export const summaryPageConfigResource: RouteResource<ConfigResponse> =
	createResource<ConfigResponse>({
		type: SUMMARY_PAGE_CONFIG_RESOURCE_KEY,
		getKey: () => SUMMARY_PAGE_CONFIG_RESOURCE_KEY,
		getData: async (_, { tenantContext: { activationId: workspaceId } }) => {
			if (!fg('jsm_summary_page_is_reporting_enabled')) {
				return { isReportingEnabled: true };
			}

			const csrConfigApiTarget = fg('jsm_project_summary_avp_m0_reporting_dev_endpoint')
				? 'reporting-dev'
				: 'reporting';

			const csrConfigApiEndpoint = `/gateway/api/jsm/${csrConfigApiTarget}/jira/workspace/${workspaceId}/v1/config`;

			const url = __SERVER__ ? '/api/v1/config' : csrConfigApiEndpoint;

			return performGetRequest<ConfigResponse>(url, {
				headers: {
					'x-ssr-service-name': 'jsm-reporting',
					'atl-workspaceid': workspaceId,
					'atl-workspacetype': 'jira',
				},
			});
		},
		maxAge: 1000 * 60 * 60 * 24, // 24 hours
	});

export const useSummaryPageConfig = (): UseResourceHookResponse<ConfigResponse> => {
	return useResource(summaryPageConfigResource);
};
